import { ReactElement } from 'react';

import {
   MedicalInformationAttachment,
   MedicalInformationAttachmentMarkAsRemovedCommand,
} from '@dreryk/egabinet-patient-medical-information-frontend-api';

import {
   Modal,
   ModalCancelButton,
   ModalCloseButton,
   ModalConfirmButton,
   ModalMaxHeight,
   ModalWidth,
} from '@dreryk/react-components';
import { useTranslate } from '@dreryk/react-common';
import { useCqrsCommand } from '@dreryk/command-query-react-common';

import { patientMedicalInformationTranslationKeys } from '../../translations';
import { refetchAllMedicalInformation } from '../shared/refetchAllMedicalInformation';

import { MedicalInformationAttachmentMarkAsRemovedForm } from './MedicalInformationAttachmentMarkAsRemovedForm';
import { MedicalInformationAttachmentMarkAsRemovedFormBean } from './MedicalInformationAttachmentMarkAsRemovedForm.types';

type MedicalInformationAttachmentRemoveModalProps = Pick<MedicalInformationAttachment, 'id'> & {
   onClose: VoidFunction;
};

export const MedicalInformationAttachmentMarkAsRemovedModal = (
   props: MedicalInformationAttachmentRemoveModalProps
): ReactElement => {
   const translate = useTranslate();
   const { executeAsync: medicalInformationAttachmentMarkAsRemoved } = useCqrsCommand<
      void,
      MedicalInformationAttachmentMarkAsRemovedFormBean
   >(
      (parameters) => {
         const command = new MedicalInformationAttachmentMarkAsRemovedCommand();
         command.reason =
            parameters.description ||
            translate(
               patientMedicalInformationTranslationKeys.previewModal.markAsRemovedAttachmentModal.reason[
                  parameters.reason
               ]
            );
         command.attachmentId = props.id;
         return command;
      },
      {
         onSuccess: () => {
            refetchAllMedicalInformation();
            props.onClose();
         },
      }
   );
   return (
      <Modal
         title={patientMedicalInformationTranslationKeys.previewModal.markAsRemovedAttachmentModal.title}
         testId={'medicalInformationAttachmentMarkAsRemoved'}
         width={ModalWidth.NORMAL}
         height={ModalMaxHeight.NORMAL}
      >
         <MedicalInformationAttachmentMarkAsRemovedForm id={props.id}>
            {({ handleSubmit, formState }) => (
               <>
                  <ModalConfirmButton
                     testId='medicalInformationAttachmentMarkAsRemoved'
                     label={patientMedicalInformationTranslationKeys.previewModal.markAsRemovedAttachmentModal.remove}
                     onClick={handleSubmit(medicalInformationAttachmentMarkAsRemoved)}
                  />
                  <ModalCancelButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
                  <ModalCloseButton onClick={props.onClose} shouldConfirmExit={formState.isDirty} />
               </>
            )}
         </MedicalInformationAttachmentMarkAsRemovedForm>
      </Modal>
   );
};
